module.exports = __webpack_public_path__ + "static/media/failed.08e04e39.svg";